import HtmlBuilder from '@/class/HtmlBuilder';
class NumberField {
    constructor(label, value = '', min) {
        this._label = label;
        this._input = NumberField.createElement(value, min);
        this._block = HtmlBuilder.createBlock(label, this._input);
        $(this._input).on('blur', NumberField.onBlurHandler);
    }
    get label() {
        return this._label;
    }
    get value() {
        return +this._input.value;
    }
    get block() {
        return this._block;
    }
    set value(value) {
        this._input.value = String(value);
    }
    set min(min) {
        this._input.setAttribute('min', String(min));
    }
    setValue(value) {
        this._input.value = value;
    }
    remove() {
        this.block.remove();
    }
    onBlur(handler) {
        $(this._input).on('blur', handler);
    }
    static createElement(value, min) {
        const input = document.createElement('input');
        input.type = 'number';
        input.setAttribute('min', min !== undefined ? String(min) : '1');
        input.setAttribute('placeholder', '0');
        input.classList.add('calcZV__input');
        input.value = value;
        return input;
    }
    static onBlurHandler() {
        const min = $(this).attr('min');
        const val = $(this).val();
        if (val === '')
            return;
        if (+val < +min)
            $(this).val(min);
    }
}
export default NumberField;
